import React from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { rangeDateReport } from '../../utils/define';
import * as moment from 'moment';

const StatisticControls = ({
  dates,
  setDates,
  groupBy,
  setGroupBy,
  onReload,
  onBack,
  ranges = rangeDateReport,
  showBack = true,
  className = ''
}) => {
  const handleApply = (event, picker) => {
    setDates({ startDate: picker.startDate, endDate: picker.endDate });
    picker.element.val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`);
  };

  const handleCancel = (event, picker) => {
    setDates({ startDate: null, endDate: null });
    picker.element.val('');
  };

  return (
    <div className={`d-flex align-items-center ${className}`}>
      {/*<label className="mr-2 mb-0">Group by:</label>*/}
      {/*<select className="form-control form-control-sm mr-3" value={groupBy} onChange={e => setGroupBy(e.target.value)}>*/}
      {/*  <option value="day">Ngày</option>*/}
      {/*  <option value="week">Tuần</option>*/}
      {/*  <option value="month">Tháng</option>*/}
      {/*</select>*/}

          <label className="mr-2 mb-0">Chọn khoảng thời gian:</label>
      <div style={{ width: 220 }} className="mr-2">
        <DateRangePicker
          onApply={handleApply}
          onCancel={handleCancel}
          initialSettings={{
            autoUpdateInput: false,
            locale: { format: 'DD/MM/YYYY', cancelLabel: 'Xóa', applyLabel: 'Chọn' },
            linkedCalendars: false,
            showDropdowns: true,
            ranges: ranges
          }}
        >
          <input
            type="text"
            className="form-control form-control-sm"
            defaultValue={dates.startDate && dates.endDate ? `${dates.startDate.format('DD/MM/YYYY')} - ${dates.endDate.format('DD/MM/YYYY')}` : ''}
            onChange={(e) => { if (e.target.value.length === 0) setDates({ startDate: null, endDate: null }); }}
          />
        </DateRangePicker>
      </div>

      {showBack && (
        <small className="text-muted ml-2"></small>
      )}

      <div className="ml-auto d-flex">
        {onBack && (
          <button className="btn btn-sm btn-secondary mr-2" onClick={onBack}>Quay lại Danh sách</button>
        )}
        {onReload && (
          <button className="btn btn-sm btn-primary" onClick={onReload}>Áp dụng</button>
        )}
      </div>
    </div>
  );
};

export default StatisticControls;
